export default __webpack_public_path__ + "static/media/background_02@2x.950677c8.jpg";